/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { getACHInformation, uploadFile, discardFile } from 'state/actions/accountState/account_data';
// component
import DirectDeposit from 'pages/dashboard/account/paymentinfo/selectmethod/directdeposit/directdeposit';



/* ========== ~~~~~~~~~~ DIRECT DEPOSIT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus }) => ({
    fields: accountData.ACH.fields,
    hasStoredData: !!Object.keys(accountData.ACH.storedData).length,
    selectedPaymentType: accountData.selectedPaymentType,
    paymentUUID: accountData.paymentUUID,
    editable: accountData.ACH.editable,
    storedData: accountData.ACH.storedData,
    accountUUID: sessionStatus.accountUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
    getACHInformation: (hasStoredData, formName, paymentUUID) => dispatch(getACHInformation(hasStoredData, formName, paymentUUID)),
    uploadFile: (file, formName) => dispatch(uploadFile(file, formName)),
    discardFile: (formName) => dispatch(discardFile(formName))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DirectDeposit);
